export default [
  
   {
      title: 'Usuarios',
      route: 'listar.usuarios',
      action: 'read',
      resource: 'usuarios',
      icon: 'UsersIcon',
   },

   {
      title:'Bodas y Reservaciones',
      icon:'HeartIcon',
      children:[
         {
            title: 'Bodas',
            route: 'listar.bodas',
            resource: 'bodas',
            action: 'read',
            icon: 'HeartIcon'
         },
         {
            title: 'Reservaciones',
            route: 'listar.reservaciones',
            resource: 'reservaciones',
            action: 'read',
            icon: 'CheckIcon'
         },
      ]
   },

   {
      title:'Agencias y Hoteles',
      icon:'ListIcon',
      children:[
         {
            title: 'Agencias',
            route: 'listar.agencias',
            action: 'read',
            resource: 'agencias',
            icon: 'ListIcon',
         },

         {
            title: 'Hoteles',
            route: 'listar.hoteles',
            action: 'read',
            resource: 'hotel',
            icon: 'ListIcon',
         },
         {
            title: 'Amenidades de hotel',
            route: 'listar.amenidades',
            action: 'read',
            resource: 'amenidades',
            icon: 'ListIcon'
         }

      ]
   },


   {
      title:'Configuraciones',
      icon:'SettingsIcon',
      children:[
         {
            title:'Integraciones',
            route:'api',
            action: 'read',
            resource: 'api'
            
         },
         {
            title: 'Roles',
            // exact:false,
            route: 'listar.roles',
            action:'read',
            resource:'roles'
         },
         {
            title: 'Permisos',
            route: 'listar.permisos',
            action: 'read',
            resource: 'permisos'
         },
         {
            title: 'Observaciones',
            route: 'listar.observaciones',
            action: 'read',
            resource: 'observaciones'
         },
         {
            title: 'Bancos',
            route: 'listar.bancos',
            action: 'read',
            resource: 'bancos',
         },
         {
            title: 'Actualizaciones',
            route: 'listar.actualizaciones',
            action: 'read',
            resource: 'actualizaciones',
         },
         {
            title: 'Plantillas de Email',
            route: 'listar.plantillas',
            action: 'read',
            resource: 'plantillas',
            icon:'ListIcon'
         },
         {
            title:'Idiomas',
            route:'idioma.list',
            action:'read',
            resource:'idiomas',
            icon:'fa-language',
            fontAwesome:true,
         }
      ]
   },

   {
      title:'Reportes',
      icon:'FileTextIcon',
      children:[
         {
            title:'Pagos de reservas',
            route: 'listar.pagos',
            action: 'read',
            resource: 'pagos'

         },{
            title:'Ventas',
            route:'listar.ventas',
            action:'read',
            resource:'ventas'
         },
         {
            title:'Depositos en garantias',
            route:'depositos',
            action:'read',
            resource:'depositos',
            icon:'ListIcon'
         }
      ]
   },
   // {
   //    title:'Transmitir Mensajes',
   //    icon:"SendIcon",
   //    resource:'enviar_mensajes',
   //    action:'write',
   //    route:'transmitir.mensajes'

   // },

   {
      header: 'Mi Cuenta',
      icon:'MinusIcon'
   },
   {
      title:'Perfil',
      route:'perfil',
      icon:'UserIcon',
      action: 'read',
      resource: 'perfil',
   },
   // {
   //    title:'Notificaciones',
   //    route:'listar.notificaciones',
   //    icon:'MessageSquareIcon',
   //    action:'read',
   //    resource:'notificaciones',
   // }

]

